'use client';

import { useRouter } from 'next/navigation';

import { IconButton } from '@hrworks/sui-core/IconButton';
import { MaterialDesignIcon } from '@hrworks/sui-core/MaterialDesignIcon';
import { ConditionalWrapper } from '@hrworks/sui-shared/components';

import { S } from './Breadcrumbs.styles';
import type { BreadcrumbsProps } from './Breadcrumbs.types';

// TODO: Can we remove this component in the future and replace it with the one from SUI?
export const Breadcrumbs = ({ breadcrumbs, ...otherProps }: BreadcrumbsProps) => {
  const router = useRouter();

  return (
    <S.Container {...otherProps} data-guide-id="breadcrumbs-container">
      <IconButton data-guide-id="breadcrumbs-back-btn" variant="unstyled" onClick={() => router.back()}>
        <MaterialDesignIcon name="arrow_back_ios" />
      </IconButton>
      {breadcrumbs?.map(({ label, href }) => (
        <S.Breadcrumb data-guide-id={`breadcrumbs-item-${label}`} key={label}>
          <ConditionalWrapper
            key={href}
            condition={!!href}
            wrapper={(children) => <S.Link href={href || ''}>{children}</S.Link>}
          >
            {label}
          </ConditionalWrapper>
        </S.Breadcrumb>
      ))}
    </S.Container>
  );
};
